import 'jquery';

/**
 * toggle Loading behavior of forms
 */
(function ($) {

  let streetNumber = $(':input[data-transform="streetNumber"]'),
    street = $(':input[data-transform="street"]');

  if (!streetNumber.length || !street.length) {
    return;
  }

  street.on('change', function () {
    let numberVal = streetNumber.val(),
      streetVal = street.val(),
      parts = streetVal.split(' '),
      lastPart = parts[parts.length - 1];

    if (
      !numberVal &&
      parts.length > 1 &&
      lastPart.length < 5 &&
      !isNaN(lastPart.charAt(0))
    ) {
      streetNumber.val(lastPart).trigger('change');
      delete parts[parts.length - 1];
      street.val(parts.join(' '));
    }

  });

}(jQuery));